export const styles = (theme) => ({
  container: {
    padding: "2rem",
    marginBottom: "2rem",
  },
  button: {
    marginRight: "1rem",
  },
});
